import React from 'react';
import classnames from 'classnames';
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import {getSelectedOptionLabel} from '../../../utils/options';
import styles from './styles.module.scss';

const Section6Text72 = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {buildingOnPillars, apartmentNum, houseFloorInBuilding, buildingOnPillarsOtherText} = context.data.pdfData;
  const currentBuildingOnPillars = buildingOnPillars === 12
    ? buildingOnPillarsOtherText
    : getSelectedOptionLabel(buildingOnPillars, context.options.buildingOnPillarsOptions);
  const buildingOnPillarsValue = ` מעל קומת ${currentBuildingOnPillars}`;

  return (
    <div className={classnames(styles.itemText, styles.innerPadding)} ref={ref}>
      <span className={styles.bold}>מיקום: </span>
      {[
        'קומה',
        houseFloorInBuilding,
        buildingOnPillars !== 2 ? buildingOnPillarsValue : '',
        ", ספרור דירתי- דירה מס'",
        apartmentNum
      ].filter(Boolean).join(' ')}.
    </div>
  );
});

export default Section6Text72;
